import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as container from '@/lib/container.js'
import * as structure from '@/lib/structure.js'

import * as user_model from '@/model/user.js'

import * as work_model from '@/model/work.js'
import * as check_model from '@/model/check.js'
import * as squad_model from '@/model/squad.js'
import * as archive_model from '@/model/archive.js'
import * as compact_model from '@/model/compact.js'
import * as company_model from '@/model/company.js'
import * as contract_model from '@/model/contract.js'




export type QueryCheckResponse = check_model.THydratedDocumentType
	& {
		compass: check_model.TCompass

	}

export function query_check (): HttpBodyUnpacking<QueryCheckResponse>
{
	return http.options('/mine/check')

}


export function create_archive
(
	data: {
		idcard: string
		emblem: string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.post('/mine/archive', data)

}


export function create_contract
(
	data: {
		company: string

	},

)
:	HttpBodyUnpacking<string>
{
	return http.post('/mine/contract', data)

}


export function update
(
	data: {
		avatar?  : string
		nickname?: string

		phone?: string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put('/mine', data)

}



export function update_archive
(
	data: {
		portrait?: string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put('/mine/archive', data)

}

export function update_contract (
	_id: string,

	data: {
		name?    : string
		phone?   : string
		outlet?  : string
		original?: string

		entrust?: boolean
		letter? : string[]

		signature?: string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put(`/mine/contract/${_id}`, data)

}

export function update_check (
	_id: string,

	data: {
		longitude: number
		latitude : number

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put(`/mine/check/${_id}`, data)

}




export type RetrieveResponse = user_model.THydratedDocumentType
	& {
		is_archive_submit: boolean

	}

export function retrieve
(): HttpBodyUnpacking<RetrieveResponse>
{
	return http.get('/mine')

}

export type RetrieveArchiveResponse = Required<archive_model.THydratedDocumentType>

export function retrieve_archive
(): HttpBodyUnpacking<RetrieveArchiveResponse>
{
	return http.get('/mine/archive')

}


export type RetrieveContractResponse = structure.Overwrite<
	contract_model.THydratedDocumentType,

	Pick<contract_model.THydratedDocumentType, 'bank'> & Pick<contract_model.TPopulatePaths, 'company'>

>

export function retrieve_contract
(_id: string): HttpBodyUnpacking<RetrieveContractResponse>
{
	return http.get(`/mine/contract/${_id}`)

}


export function retrieve_contract_compact
(_id: string): HttpBodyUnpacking<compact_model.THydratedDocumentType>
{
	return http.get(`/mine/contract/${_id}/compact`)

}


export type RetrieveContractPagerResponse = RetrieveContractResponse[]

export function retrieve_contracts
(): HttpBodyUnpacking<RetrieveContractPagerResponse>
{
	return http.get('/mine/contracts')

}


export function retrieve_work
(_id: string): HttpBodyUnpacking<work_model.THydratedDocumentType>
{
	return http.get(`/mine/work/${_id}`)

}


type RetrieveLeagueResponse = {
	name: string

	company_quantity : number
	manager_quantity : number
	contract_quantity: number

}

export function retrieve_league
(): HttpBodyUnpacking<RetrieveLeagueResponse>
{
	return http.get('/mine/league')

}


export function retrieve_squads
(): HttpBodyUnpacking<squad_model.THydratedDocumentType[]>
{
	return http.get('/mine/squads')

}

export function retrieve_managed_companies
(
	params: container.PagerParams<
		{
			keyword?: string

		}

	>,

)
:	HttpBodyUnpacking<company_model.THydratedDocumentType[]>
{
	return http.get('/mine/managed/companies', { params })

}




export function delete_ (): Promise<void>
{
	return http.delete('/mine')

}
